import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import {
  integer,
  required,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import ValidationService from '@/services/ValidationService';

export default {
  name: "adminEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
  },

  mixins: [ValidationService],

  data() {
    return {
      itemData: [],
      submitted: false,
      isLoading: false,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      itemExists: false,
      acdYearArr: [],
      transactionCategoryArr: [],
      CONFIG,
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required,
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required,
        integer,
        maxLength: maxLength(9),
        minValue: minValue(0)
      },
      acd_year_id: {
        required,
        integer: true,
        minValue: 1,
      },
    },
  },

  watch: {
    "itemData.acd_year_id"() {
      this.validationErrors.acd_year_id = [];
    }
  },

  computed: {
    isProtected() {
      const protectedItems = Object.keys(CONFIG.PROTECTED_ITME_TYPES);
      const itemType = this.itemData?.item_type;
      return itemType ? protectedItems.includes(String(itemType)) : true;
    }
  },

  methods: {
    async checkDuplicateItem() {
        try {
            const response = await axios.get("/item/checkDuplicateItem", {
                params: {
                    id: this.itemData.id,
                    item_name: this.itemData.p_item_name,
                },
            });
            this.itemExists = response.data.exists;
            this.submitted = false;
            this.disabled = false;
        } catch (error) {
            console.error('An error occurred:', error);
        }
    },

    getAcademicYear() {
      axios.get("period/periodList")
        .then(res => {
          this.acdYearArr = res.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getTransactionCategories() {
      axios.get(`/transactionCategory/getTransactionCategoryArray?type=${CONFIG.TRANSACTION_TYPE.INCOME}`)
        .then(res => {
          const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
          this.transactionCategoryArr = [
            { id: 0, text: 'Select Transaction Category' },
            ...categoryList.map((category) => ({
              id: category.id,
              text: category.text ?? category.category_name ?? "",
            }))
          ];
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getDetail() {
      axios.get(`item/detail/${this.$route.params.id}`, { params: { is_edit: true } })
        .then(res => {
          if (res.data && res.data.data) {
            this.itemData = res.data.data;
            this.isLoading = false;
          }
        })
        .catch(error => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    async confirmUpdate() {
      if (this.disabled) return;
      this.submitted = this.disabled = true;
      await this.checkDuplicateItem();
      if (this.itemExists) {
        this.$notification.error("Payment Item Name is already exist.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      this.update();
    },

    update() {
      this.submitted = true;
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.itemData.loginID = this.$store.state.user.id;
      const payload = {
        ...this.itemData,
        transaction_category_id: this.itemData.transaction_category_id && this.itemData.transaction_category_id !== 0
          ? this.itemData.transaction_category_id
          : 0,
      };
      axios.post(`item/update/${this.$route.params.id}`, payload)
        .then(res => {
          if (res.data.success === true) {
            this.$notification.success("Item Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "itemList"
            });
          } else {
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.printValidationError(error.response);
          } else {
            this.printValidationError(error.response);
          }
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => {
          this.isLoading = this.disabled = false;
        })
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYear();
    this.getTransactionCategories();
    this.getDetail();
    this.getTransactionCategories();
  },
};
